<template>
    <div class="card">
        <div class="card-header pb-0">
            <h3>Button Outline</h3>
        </div>
        <div class="card-body">
            <pre class="helper-classes">.btn-outline-primary {
    border-color: #ab8ce4;
    color: #ab8ce4;
    background-color: transparent;
    }
    .btn-outline-secondary {
    border-color: #26c6da;
    color: #26c6da;
    background-color: transparent;
    }
    .btn-outline-success {
    border-color: #00c292;
    color: #00c292;
    background-color: transparent;
    }
    .btn-outline-danger {
    border-color: #FF5370;
    color: #FF5370;
    background-color: transparent;
    }
    .btn-outline-info {
    border-color: #4099ff;
    color: #4099ff;
    background-color: transparent;
    }
    .btn-outline-light {
    border-color: #eeeeee;
    color: #eeeeee;
    background-color: transparent;
    }
    .btn-outline-dark {
    border-color: #2a3142;
    color: #2a3142;
    background-color: transparent;
    }
    .btn-outline-warning {
    border-color: #f3d800;
    color: #f3d800;
    background-color: transparent;
    }</pre>
        </div>
    </div>
</template>